import { useMemo } from 'react';
import { AnalysisDetail } from '@/api/domains/analyses/types';

interface DocumentMetadata {
  doc1Name: string;
  doc2Name: string;
  doc1Source: string;
  doc2Source: string;
}

export const useDocumentMetadata = (
  analysis: AnalysisDetail | undefined
): DocumentMetadata | null => {
  return useMemo(() => {
    if (!analysis) return null;
    return {
      doc1Name: analysis.document1_name,
      doc2Name: analysis.document2_name,
      doc1Source: analysis.document_1_id,
      doc2Source: analysis.document_2_id
    };
  }, [analysis]);
};
